module.exports = __webpack_public_path__ + "static/img/icon_music.a1b7a69e.svg";